const tones: Record<string, string> = {
  DRAFT:                  "bg-slate-100 text-slate-600",
  SUBMITTED:              "bg-amber-50 text-amber-700 border border-amber-200",
  DEPT_HEAD_APPROVED:     "bg-blue-50 text-blue-700 border border-blue-200",
  FINANCE_APPROVED:       "bg-indigo-50 text-indigo-700 border border-indigo-200",
  PROCUREMENT_REVIEWED:   "bg-violet-50 text-violet-700 border border-violet-200",
  MD_APPROVED:            "bg-emerald-100 text-emerald-800",
  APPROVED:               "bg-emerald-100 text-emerald-800",
  ACCEPTED:               "bg-emerald-100 text-emerald-800",
  SENT:                   "bg-blue-100 text-blue-700",
  AUTHORIZED:             "bg-indigo-100 text-indigo-700",
  CLOSED:                 "bg-slate-200 text-slate-600",
  REJECTED:               "bg-red-100 text-red-700",
  CANCELLED:              "bg-red-50 text-red-500",
  OPEN:                   "bg-amber-50 text-amber-700",
  PENDING:                "bg-amber-50 text-amber-700",
  ACTIVE:                 "bg-emerald-100 text-emerald-700",
  SUSPENDED:              "bg-orange-100 text-orange-700",
  DELISTED:               "bg-red-100 text-red-700",
  PASSED:                 "bg-emerald-100 text-emerald-700",
  FAILED:                 "bg-red-100 text-red-700",
  APPROVED_WITH_CONDITIONS: "bg-amber-100 text-amber-700",
  UNDER_OBSERVATION:      "bg-orange-100 text-orange-700",
  MITIGATED:              "bg-blue-100 text-blue-700",
};

export function ProcStatusBadge({ value }: { value?: string | null }) {
  const key = (value ?? "").toUpperCase();
  const cls = tones[key] ?? "bg-slate-100 text-slate-600";
  const label = (value ?? "UNKNOWN").replaceAll("_", " ");
  return (
    <span className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold ${cls}`}>
      {label}
    </span>
  );
}
